/**
 * Badge-number parser.
 *   NECS-A-EXC-CEO-TX-0001 ->
 *     { ok, kind:'admin',  dept:'EXC', position:'CEO', state:'TX', sequence:'0001' }
 *   NECS-S-V-STA-NTX-TX-0001 ->
 *     { ok, kind:'staff',  role:'V', position:'STA', region:'NTX', state:'TX', sequence:'0001' }
 *
 * For legacy NECS-1xxxxx / NECS-2xxxxx numbers, returns { ok:false, raw }.
 */
export function parseBadge(badge) {
  if (!badge || typeof badge !== 'string') return { ok: false, raw: '' };
  const parts = badge.trim().split('-');
  if (parts[0] !== 'NECS') return { ok: false, raw: badge };

  if (parts[1] === 'A' && parts.length === 6) {
    const [, , dept, position, state, sequence] = parts;
    return { ok: true, kind: 'admin', dept, position, state, sequence, raw: badge };
  }
  if (parts[1] === 'S' && parts.length === 7) {
    const [, , role, position, region, state, sequence] = parts;
    return { ok: true, kind: 'staff', role, position, region, state, sequence, raw: badge };
  }
  return { ok: false, raw: badge };
}

// Reverse lookups so the chip can show the human-readable label as a tooltip.
export const DEPT_LABEL_BY_CODE = {
  EXC: 'Executive / C-Suite',
  OPS: 'Operations',
  FIN: 'Finance & Accounting',
  HRX: 'Human Resources',
  TEC: 'Information Technology',
  LEG: 'Legal & Compliance',
  SLS: 'Sales & Business Development',
  MKT: 'Marketing & Communications',
  CSV: 'Customer Service',
  PRC: 'Procurement & Supply Chain',
  SAF: 'Safety & Risk Management',
  TRN: 'Training & Development',
};

export const ADMIN_POSITION_LABEL_BY_CODE = {
  CEO: 'CEO',
  DIR: 'Director',
  MGR: 'Manager',
  ASD: 'Assistant Director',
  AGT: 'Admin Agent',
};

export const STAFF_ROLE_LABEL_BY_CODE = {
  V: 'Valet',
  C: 'Cleaner',
};

export const STAFF_POSITION_LABEL_BY_CODE = {
  RGM: 'Regional Manager',
  RGS: 'Regional Supervisor',
  CRL: 'Crew Leader',
  STA: 'Site Agent',
};
